import React, {useEffect, useState} from 'react'
import {EDITOR_TABS_LIST} from "../common/constants/quote.constant";

const editorTabs = EDITOR_TABS_LIST;

const EditorTabs = ({selectedTab, setSelectedTab}) => {
    return (
        <>
            <div className="">
                <div className="flex justify-center items-center my-auto">
                    {editorTabs?.map((editorTabItem, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setSelectedTab(editorTabItem?.key)
                            }}
                            className={`editor-tab ${editorTabItem.key === selectedTab ? 'editor-tab-selected' : ''}`}>
                            <div className="mx-4 my-2">{editorTabItem.label}</div>
                        </button>
                    ))}
                </div>
            </div>
        </>
    )
}

export default EditorTabs
